import { CobrandIdentifier } from 'features/cobrand/types';

const commonColors = {
  errorMain: '#923133',
  grey: {
    300: '#F2F8FA', // Gray 1, Brand Primary Background
    400: '#D9E3E7', // Gray 3, Brand Secondary Background
    500: '#A6B4BA', // Gray 5
    600: '#78868E', // Gray 7
    700: '#4E5961', // Gray 9
    800: '#282F35', // Gray 11
    900: '#161B1F', // Gray 12
  },
  green: {
    800: '#5AA746',
  },
  red: {
    800: '#F05B60',
  },
  white: '#FFFFFF',
  blackWithOpacity40: '#00000040',
  extendedPrimary1: '#F0F4F5',
};

export const color: Record<CobrandIdentifier, Record<string, any>> = {
  [CobrandIdentifier.WELLFRAME]: {
    ...commonColors,
    primaryMain: '#0080A3',
    secondaryMain: '#0E98BE',
    brandShade1: '#19566A',
    brandShade2: '#0F3541',
    brandBackgroundPrimary: '#F2F8FA',
    brandBackgroundSecondary: '#D9E3E7',
    brandTint: '#B0DEEA',
  },
  [CobrandIdentifier.HARVARD_PILGRIM]: {
    ...commonColors,
    primaryMain: '#E31837',
    secondaryMain: '#5F5F5F',
    brandShade1: '#88061F',
    brandShade2: '#510312',
    brandBackgroundPrimary: '#F1F1F1',
    brandBackgroundSecondary: '#DBDBDB',
    brandTint: '#F5B0BA',
  },
  [CobrandIdentifier.BCBS_KANSAS_CITY]: {
    ...commonColors,
    primaryMain: '#007CBD',
    secondaryMain: '#005A89',
    brandShade1: '#00527E',
    brandShade2: '#00314B',
    brandBackgroundPrimary: '#F2F8FB',
    brandBackgroundSecondary: '#DBECF5',
    brandTint: '#A8D2E8',
  },
  [CobrandIdentifier.BCBS_SOUTH_CAROLINA]: {
    ...commonColors,
    primaryMain: '#0067AC',
    secondaryMain: '#0099CC',
    brandShade1: '#004472',
    brandShade2: '#002944',
    brandBackgroundPrimary: '#F2F7FA',
    brandBackgroundSecondary: '#DAE9F2',
    brandTint: '#A6C9E2',
  },
  [CobrandIdentifier.BCBS_TENNESSEE]: {
    ...commonColors,
    primaryMain: '#005EB9',
    secondaryMain: '#013F7C',
    brandShade1: '#003E7B',
    brandShade2: '#00254A',
    brandBackgroundPrimary: '#F0F0F0',
    brandBackgroundSecondary: '#D6E5F3',
    brandTint: '#A6C6E6',
  },
  [CobrandIdentifier.HSCSN]: {
    ...commonColors,
    primaryMain: '#034E8C',
    secondaryMain: '#0071CE',
    brandShade1: '#02345E',
    brandShade2: '#011F38',
    brandBackgroundPrimary: '#F2F6F9',
    brandBackgroundSecondary: '#DCE6EF',
    brandTint: '#A9C3D8',
  },
  [CobrandIdentifier.CARE_FIRST]: {
    ...commonColors,
    primaryMain: '#003359',
    secondaryMain: '#086EA1',
    brandShade1: '#00223B',
    brandShade2: '#001424',
    brandBackgroundPrimary: '#F2F5F7',
    brandBackgroundSecondary: '#DBE2E8',
    brandTint: '#A8BAC7',
  },
  [CobrandIdentifier.CARE_ELEVATE]: {
    ...commonColors,
    primaryMain: '#345181',
    secondaryMain: '#C81766',
    brandShade1: '#233656',
    brandShade2: '#152034',
    brandBackgroundPrimary: '#F5F6F9',
    brandBackgroundSecondary: '#E3E7ED',
    brandTint: '#BAC4D4',
  },
};
